// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"daad9cd9","395":"c6582281","510":"bba01f41","746":"99bb6b96"}[chunkId] + ".chunk.js";
};